import { ComingSoonEmptyState } from '../shell/empty-states/coming-soon-empty-state.js';

export function ImprovementLogPage(): JSX.Element {
  return (
    <ComingSoonEmptyState
      title="Improvement log"
      description="Tracks what's on the radar, what you're working on, and what's been resolved. Lands with the Improvement Log epic."
    />
  );
}
